<template>
  <div>
    <div :class="'rating-stars rating-stars-'+size">
      <rating-stars :percent="percentage" />
      <em>
        {{ averageOneDecimal }}
        <template
          v-if="showAverageText && ratingWord"
        >
          - <span class="description">"{{ ratingWord }}"</span>
        </template>
        <template v-if="!averageOfTotal.hidden && !averageOfTotal.written">
          ({{ total }})
        </template>
      </em>
    </div>
    <div v-if="!averageOfTotal.hidden">
      <div v-if="averageOfTotal.written">
        {{ $t('rating:ratingAvg', {count:total}) }}
      </div>
    </div>
    <div
      v-if="showAverageTextBelow && ratingWord"
      class="description"
    >
      "{{ ratingWord }}"
    </div>
  </div>
</template>
<script>
import RatingCalc from 'mixins/RatingCalc';

import RatingStars from 'components/RatingStars.vue';

export default {
  components: {
    RatingStars,
  },
  mixins: [RatingCalc],
  props: {
    average: {
      type: Number,
      required: true,
      default: 0,
    },
    total: {
      type: Number,
      required: true,
      default: 0,
    },
    showAverageText: {
      type: Boolean,
      default: false,
    },
    averageOfTotal: {
      type: Object,
      default: () => ({
        hidden: false,
        written: true,
      }),
    },
    showAverageTextBelow: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
  },
  computed: {
    percentage() {
      return this.rcMixin_percentage(this.average);
    },
    averageOneDecimal() {
      return this.rcMixin_averageOneDecimal(this.average);
    },
    ratingWord() {
      return this.rcMixin_ratingWord(this.average, 3.5);
    },
  },
};
</script>
